import { createTheming } from '@callstack/react-theme-provider'
import { lighten } from 'polished'
import colors from '../lib/colors'

const themes = {
  default: {
    themeName: 'default',
    colors: {
      primary: colors.darkGreen,
      text: colors.black,
      bodyBg: colors.gray,
      headerBg: colors.darkGreen,
      link: colors.green,
      ...colors,
    },
  },
  dark: {
    themeName: 'dark',
    colors: {
      primary: lighten(0.05, colors.darkGreen),
      text: colors.white,
      bodyBg: colors.black,
      headerBg: colors.darkGreen,
      link: lighten(0.15, colors.green),
      ...colors,
    },
  },
}

const { ThemeProvider, withTheme, useTheme } = createTheming(themes.default)

export { ThemeProvider, withTheme, useTheme, themes, colors }
